import React from 'react';
import { PropTypes } from 'prop-types';
import { useSendMessageModal } from '@molecules/SendMessageModal';

const PropertyInquiryButton = ({
    id,
    graphID,
    firstName,
    lastName,
    fullName,
    companyName,
    companyID,
    title,
    displayLocation,
    businessType,
    photoURL,
    url,
    isLoggedIn = true,
    messageAttributes,
    onMessage = () => {},
}) => {
    const { openModal: openSendMessageModal } = useSendMessageModal();

    const openModal = () => {
        openSendMessageModal({
            businessType,
            companyName,
            companyID,
            designations: '',
            displayLocation,
            firstName,
            fullName,
            graphID,
            id,
            lastName,
            photoURL,
            title,
            url,
            messageAttributes,
            onMessage,
        });
    };

    if (!isLoggedIn) {
        return null;
    }

    return (
        <button
            className="btn btn-primary"
            type="button"
            tabIndex={0}
            onClick={() => openModal()}
            onKeyDown={e => {
                if (e.keyCode === 13) {
                    openModal();
                }
            }}
        >
            Make an Inquiry
        </button>
    );
};

PropertyInquiryButton.propTypes = {
    id: PropTypes.number,
    graphID: PropTypes.string,
    companyID: PropTypes.number,
    isLoggedIn: PropTypes.bool,
    companyName: PropTypes.string,
    title: PropTypes.string,
    fullName: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    displayLocation: PropTypes.string,
    businessType: PropTypes.array,
    photoURL: PropTypes.string,
    url: PropTypes.string,
    messageAttributes: PropTypes.object,
    onMessage: PropTypes.func,
};

export default PropertyInquiryButton;
